import {
  CreateGUFAddRealisedInstallationTask,
  EditGUFAddRealisedInstallationTask,
} from "@nens/brostar/uploadapi-client";

import { addSchema } from "@/helpers/schema-utils";

import { pickGufPrimitiveLibraryFields } from "../guf-schema-primitive-library";

/**
 * Schema for RealisedSurfaceInfiltration within a RealisedInstallation
 */
export const realisedSurfaceInfiltrationSchema = addSchema<
  (
    | CreateGUFAddRealisedInstallationTask
    | EditGUFAddRealisedInstallationTask
  )["sourcedocumentData"]["realisedSurfaceInfiltrations"]
>({
  type: "array",
  title: "Gerealiseerde oppervlakte-infiltraties",
  minItems: 0,
  items: {
    type: "object",
    title: "Gerealiseerde oppervlakte-infiltratie",
    required: ["realisedSurfaceInfiltrationId", "realisedSurfaceInfiltrationPos"],
    properties: {
      ...pickGufPrimitiveLibraryFields([
        "realisedSurfaceInfiltrationId",
        "realisedSurfaceInfiltrationPos",
      ]),
    },
  },
});
